/* eslint-disable react/prop-types */
// Web component only
import React from 'react';
// import { StyleSheet } from 'react-native';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
//
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '@web/css/styles.css'; // extends

const Carousel = (props) => {
  const { children, innerRef = () => {} } = props;
  return (
    <Slider {...props} ref={(slider) => innerRef(slider)}>
      {children}
    </Slider>
  );
};

Carousel.propTypes = {
  children: PropTypes.node.isRequired,
};

// const styles = StyleSheet.create({
// });

export default Carousel;
